<div
  style="margin: 0; padding: 0; display: flex; flex-direction: column"
  [ngClass]="{
    's-panel-frame': true,
    'addFitting-mode': addFittingMode ? true : false,
    'manage-mode': manageMode ? true : false,
  }"
>
  <div
    style="
      margin: 0;
      padding: 0;
      display: flex;
      flex-direction: column;
      min-height: 98vh;
      width: -webkit-fill-available;
    "
  >
    <div style="display: flex; height: 30px; width: -webkit-fill-available">
      <sysque-select-system
        (valueChanged)="onValueChanged($event)"
        [systemInfo$]="stateSystemInfo$"
        [selectedSystem]="dockedState.selectedSystem"
        [panelName]="'systemPanel'"
        style="width: -webkit-fill-available"
      ></sysque-select-system>

      <sysque-system-operations></sysque-system-operations>

      @if (isLoading) {
        <div class="loading-overlay">
          <div style="z-index: 2; width: 70%">
            <sysque-progress-bar
              #sysqueProgress
              [actionName]="progressBarTitle"
              [actionText]="progressBarBody"
              [value]="false"
            ></sysque-progress-bar>
          </div>
        </div>
      }

      @if (areMissing || isError || showHangerAlert) {
        <div class="loading-overlay">
          <dx-dialog id="errorDownload">
            <div class="dialog-content">
              <p class="dialog-title">{{ dialogTitle }}</p>
              <p class="dialog-body">{{ dialogBody }}</p>
            </div>
            <div class="button-grid">
              <button class="button-yes-no" (click)="onYesClick()">{{ buttonOkOrYes }}</button>
              <button class="button-yes-no" [hidden]="isButtonNoDisabled" (click)="onNoClick()">{{ buttonNo }}</button>
            </div>
          </dx-dialog>
        </div>
      }
    </div>
    @if (showAddFittingBtn && !manageMode && !addFittingMode) {
      <modus-checkbox
        [checked]="dockedState.isHangerNeeded"
        (checkboxClick)="onHangerValueChanged($event)"
        class="modus-checkbox-r hanger-check"
        checked
        [label]="hangerNeededLabel"
      ></modus-checkbox>
    }

    <ng-container style="height: 350px">
      @if (isPanelSystem && showAddFittingBtn && !manageMode && !addFittingMode) {
        <sysque-panel-system
          [checkBoxConfigs]="checkBoxConfigs"
          [panelsList]="panelsList"
          (panelValueChanged)="onPanelValueChanged($event)"
          (panelFocusIn)="onPanelFocusIn()"
          (checkedCircuit)="getUpdatedCircuit($event)"
        ></sysque-panel-system>
      }

      @if (!isPanelSystem && !addFittingMode && showAddFittingBtn && !manageMode && !addFittingMode) {
        <sysque-cable-tray-system
          [addFittingMode]="false"
          (onProjectChanged)="onProjectValueChanged($event)"
          [projectList]="projectList"
          [wireSpecList]="wireSpecList"
          [isClearance]="dockedState.isCableTrayClearanceNeeded"
          (updateIsClearance)="updateIsClearance($event)"
          (projectFocusIn)="onProjectFocusIn()"
          [needToShow]="isClearanceCategory"
          (numberBoxItemsChanged)="onTextInputChanged($event)"
          (onWireFillChanged)="onWireFillValueChanged($event)"
          [resetEvent]="resetNumberBoxEvent"
        ></sysque-cable-tray-system>
      }

      @if (isPanelSystem) {
        <div class="apply-container mt-2">
          <dx-button
            class="button-apply apply-section"
            [text]="applyToSelectionButton"
            (onClick)="applyPanelData()"
            [disabled]="disableApplyBtn"
            [visible]="showApplyBtn"
          ></dx-button>
        </div>
      }

      @if (showApplyBtn) {
        <div class="v-line"></div>
      }

      @if (showAddFittingBtn) {
        <sysque-category-scope
          id="right-click-target"
          (contextmenu)="onRightClick($event)"
          [key]="'sp'"
          [selectedSystem]="dockedState.selectedSystem"
          [addFittingMode]="false"
          [manageMode]="false"
          [categoryList$]="categoryList$"
          [fittingList]="dockedState.fittingList"
          [selectedCategory]="dockedState.selectedCategory"
          (categoryChanged)="onCategoryChanged($event)"
          (copiedItemListChanged)="updateCopiedItemList($event)"
        >
        </sysque-category-scope>
      }

      @if (showRightClickMenu) {
        <dx-context-menu
          class="right-context-menu"
          [dataSource]="rightClickMenuItems"
          target="#right-click-target"
          (onShowing)="onContextMenuShowing($event)"
          (onItemClick)="onContextMenuItemClick($event)"
        >
        </dx-context-menu>
      }
    </ng-container>

    <div
      [ngClass]="{
        'std-position': addFittingMode ? false : true,
        'manage-mode-position': addFittingMode || manageMode ? true : false,
      }"
    >
      @if (showRootPath) {
        <sysque-root-path-selector [manageMode]="false"></sysque-root-path-selector>
      }
    </div>
  </div>
</div>
